/* rein-pdp-v2.js — PDP-V2 R3 (2026-10-07). Loaded only by the rein-pdp-v2-main and
 * rein-coll-v2-grid sections (alternate templates product.pdp-v2 / collection.v2).
 *  1. Product: keep the sticky gallery below the sticky header (CSS var on the wrapper).
 *  2. Collection: publish the header height as --rein-header-h (sticky sidebar offset) and
 *     label the drawer button "Filter & sort" (the theme's collection-actions snippet prints
 *     "Filters"); re-applied after every facets.js re-render of #CollectionActions.
 *  3. Product (R3): every accordion in the lower sections starts COLLAPSED — the shared
 *     sections (Documents & Manuals opens its first row) are not PDP-V2 files, so the
 *     theme's own collapsible-expandable.collapse() is called once after they define.
 * No cart or checkout calls, no third-party code. */
(function () {
  'use strict';
  var header = document.querySelector('[id^="shopify-section-"][class*="section-header"]');
  var headerOffset = function () {
    if (!header) return 0;
    var always = header.classList.contains('section-header-sticky-always');
    var onScroll = header.classList.contains('section-header-sticky') && !header.classList.contains('section-header-hidden');
    return (always || onScroll) ? header.offsetHeight : 0;
  };

  /* 1 · sticky gallery */
  var sticky = document.querySelector('[data-rein-pv2-sticky]');
  var setTop = function () {
    var h = headerOffset();
    if (sticky) sticky.style.setProperty('--pv2-sticky-top', (h + 16) + 'px');
    document.documentElement.style.setProperty('--rein-header-h', (header ? header.offsetHeight : 0) + 'px');
  };
  var raf = false;
  var tick = function () { if (raf) return; raf = true; window.requestAnimationFrame(function () { raf = false; setTop(); }); };
  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', tick, { passive: true });
  setTop();

  /* 2 · collection toolbar label */
  if (document.documentElement.classList.contains('rein-cv2')) {
    var relabel = function () {
      var btn = document.querySelector('#CollectionActions .button-sidebar-drawer-open');
      if (!btn) return;
      for (var i = 0; i < btn.childNodes.length; i++) {
        var n = btn.childNodes[i];
        if (n.nodeType === 3 && n.textContent.trim()) n.textContent = ' Filter & sort';
      }
    };
    var start = function () {
      relabel();
      /* HOTFIX 2026-10-08: keep the "In stock only" switch (outside the re-rendered .js-filter groups) in step
         with the URL after every facets.js re-render, e.g. "Clear all" or back/forward. */
      var syncInStock = function () {
        var sw = document.getElementById('rcf-instock');
        if (!sw) return;
        var on = false;
        try { on = new URLSearchParams(window.location.search).getAll('filter.v.availability').indexOf('1') !== -1; } catch (e) {}
        if (sw.checked !== on) sw.checked = on;
      };
      var grid = document.getElementById('ProductGridContainer');
      if (grid && window.MutationObserver) new MutationObserver(function () { window.requestAnimationFrame(syncInStock); }).observe(grid, { childList: true });
      window.addEventListener('popstate', syncInStock);
      var actions = document.getElementById('CollectionActions');
      if (actions && window.MutationObserver) {
        new MutationObserver(function () { window.requestAnimationFrame(relabel); }).observe(actions, { childList: true, subtree: true });
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  }

  /* 3 · product: lower-section accordions collapsed on load */
  if (document.documentElement.classList.contains('rein-pv2-page')) {
    var collapseAll = function () {
      document.querySelectorAll('.rein-psec collapsible-expandable[expanded="true"]').forEach(function (el) {
        if (typeof el.collapse === 'function') el.collapse();
        else {
          el.setAttribute('expanded', 'false');
          var t = el.querySelector('.facet-toggle');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
    };
    var run = function () {
      if (window.customElements && customElements.whenDefined) customElements.whenDefined('collapsible-expandable').then(collapseAll, collapseAll);
      else collapseAll();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  }
})();
